import { render, staticRenderFns } from "./RiskFactorDeleteDialog.vue?vue&type=template&id=36aa588c&"
import script from "./RiskFactorDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./RiskFactorDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports